import { Image, Timer, type LucideIcon } from "lucide-react";
import type { ContentPlacement } from "../../lib/types";

export interface ContentType {
	placement: ContentPlacement;
	label: string;
	description: string;
	icon: LucideIcon;
	/** Some placements are a single slot per campaign — a corner only holds one. */
	multiple: boolean;
}

/**
 * The catalogue the "Add content" picker reads from. Adding a promotional
 * surface means adding a row here and an editor for it; nothing else in the
 * library needs to know it exists.
 */
export const CONTENT_TYPES: readonly ContentType[] = [
	{
		placement: "popup",
		label: "Popup",
		description: "A full-screen image, shown once a day while the campaign runs.",
		icon: Image,
		multiple: true,
	},
	{
		placement: "floating_ticker",
		label: "Floating ticker",
		description: "A small corner badge with a countdown and progress toward the next reward.",
		icon: Timer,
		multiple: false,
	},
];

export const contentTypeFor = (placement: ContentPlacement): ContentType | undefined =>
	CONTENT_TYPES.find((type) => type.placement === placement);
